import ParticleHeaderBg from '../ParticlesBg/ParticlesHeader/ParticleHeaderBg';
import{ CgChevronDoubleRight } from "react-icons/cg";
import { Link } from 'react-router-dom';

const Head = () =>{
    return(
       <>  
        <div className="head">
        <ParticleHeaderBg/>
        <div className='hele'>
        <div className='lhele'>
           <h1 data-aos="zoom-in" className="head_name" data-aos-offset="10">Aman Verma</h1>
           <h4 className="head_sub" data-aos="zoom-in" data-aos-offset="0">Web Developer | Competetive Coder</h4>
           </div>
           
           <div className='nxt' ><Link to="/about"> <CgChevronDoubleRight style={{color: "white"}}/></Link></div>
           </div>
        </div>   
       </> 
    )
}
export default Head